<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex items-center justify-between">
                <div>
                    <span class="text-base font-extrabold text-slate-700 lg:text-xl">Filter to Groups</span>
                    <div class="text-sm text-slate-500">
                        Limit contacts to those with a preferred group in a collection
                    </div>
                </div>
                <vx-toggle v-model="filterToGroups" :disabled="props.disabled" size="lg"></vx-toggle>
            </div>
            <div v-if="filterToGroups" class="mt-5">
                <select-group-collection size="lg" v-model="model" :disabled="props.disabled"></select-group-collection>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxToggle } from '@voxie/frontend-components';
import { onMounted, ref, watch } from 'vue';
import SelectGroupCollection from '../../../general/SelectGroupCollection.vue';

const model = defineModel();

const props = defineProps({
    disabled: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const filterToGroups = ref(false);

watch(filterToGroups, (newFilterToGroups) => {
    if (false === newFilterToGroups) {
        model.value = null;
    }
});

watch(
    () => props.disabled,
    (value) => {
        if (value) {
            filterToGroups.value = false;
        }
    }
);

onMounted(() => {
    if (model.value !== null) {
        filterToGroups.value = true;
    }
});
</script>
